// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


/* SLIDE UP */
let slideUp = (target, duration=500) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
  }, duration);
}

/* SLIDE DOWN */
let slideDown = (target, duration=500) => {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

/* TOOGLE */
var slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}

class ClaspsFunctionality extends HTMLElement {
  constructor() {
    super();

    this.itemsSlider = this.querySelector('[data-slider]');
    this.closestVariantSelector = this.closest('variant-radios') || this.closest('variant-selects');

    if (this.closestVariantSelector) {
      this.closestVariantSelector.addEventListener('variant:changed', this.updateProductItems.bind(this));
    }
  }


	updateProductItems(event) {
		const selectedVariant = event.detail.variant;
		const productItems = this.itemsSlider.querySelectorAll('[data-clasp-product-item]');

		productItems.forEach((productItem) => {
			const product = JSON.parse(productItem.querySelector('[data-clasp-product-json]').innerHTML);
			const matchingVariant = product.variants.find((variant) => variant.option1 == selectedVariant.option1 && variant.option2 == selectedVariant.option2 && variant.option3 == selectedVariant.option3);
			if (matchingVariant) {
				const productItemLink = productItem.querySelector('[data-clasp-product-url]');
				const linkParams = new URLSearchParams(productItemLink.search);
				linkParams.set('variant', matchingVariant.id);
				productItemLink.search = linkParams.toString();
                
			}
		})

	}
}

customElements.define('clasps-functionality', ClaspsFunctionality);

class LinkedProductOption extends HTMLElement {
	constructor() {
		super();

		this.fixedOptionPosition= parseInt(this.dataset.optionPosition);
		this.fixedOptionValue = this.dataset.optionValue;
		this.link = this.querySelector('[data-linked-product-url]');
		this.product = JSON.parse(this.querySelector('[data-linked-product-json]').innerHTML);
		this.selectedVariant = JSON.parse(this.querySelector('[data-linked-product-initially-selected-variant-json]').innerHTML);
		
		this.priceDifference = this.querySelector('[data-linked-product-price-difference]');


    this.closestVariantSelector = this.closest('variant-radios') || this.closest('variant-selects');

    if (this.closestVariantSelector) {
      this.closestVariantSelector.addEventListener('variant:changed', this.updateLink.bind(this));
    }
	}

	updateLink(event) {
		const newVariant = event.detail.variant;

		const currentURL = this.link.getAttribute('href');
		const [url, paramsString ] = currentURL.split('?');
		const searchParams = new URLSearchParams(paramsString);

		const newSelectedOptionsObject = {
      option1: newVariant.option1,
      option2: newVariant.option2,
      option3: newVariant.option3,
    };
    
		newSelectedOptionsObject[`option${this.fixedOptionPosition}`] = this.fixedOptionValue;

		const matchingVariant = this.product.variants.find(
			(variant) => {
        return variant.option1 == newSelectedOptionsObject.option1 && variant.option2 == newSelectedOptionsObject.option2 && variant.option3 == newSelectedOptionsObject.option3;
      }
		) || this.product.variants.find((variant) => variant.available);
		
		if (matchingVariant) {
			this.selectedVariant = matchingVariant;
		}

		if (this.priceDifference) {
			const priceDifference = this.selectedVariant.price - newVariant.price;
			const priceDifferenceSign = priceDifference < 0 ? '-' : '+';
			if (priceDifference != 0) {
				this.priceDifference.style.display = 'block';
				this.priceDifference.innerHTML = priceDifferenceSign + Shopify.formatMoney(Math.abs(priceDifference));
			} else {
				this.priceDifference.style.display = 'none';
			}
		}

		searchParams.set('variant', this.selectedVariant.id);
		const newURL = url + '?' + searchParams.toString();
		this.link.setAttribute('href', newURL);
	}
}

customElements.define('linked-product-option', LinkedProductOption);

class ProductInformationSlider extends HTMLElement {
  constructor() {
    super();

    this.goToNextSlideButton = this.querySelector('[data-go-to-next-slide]');
    this.slider = this.querySelector('[data-slider]');

    if (this.goToNextSlideButton) {
      this.goToNextSlideButton.addEventListener('click', this.goToNextSlide.bind(this));
    }
  }

  goToNextSlide(event) {
    event.preventDefault();
    const flkty = Flickity.data(this.slider);
    flkty.next();
    if (flkty.options.autoplay) {
      flkty.stopPlayer();
      flkty.playPlayer();
    }
    
  }
}

customElements.define('product-information-slider', ProductInformationSlider);

class FeaturesWithMakrkers extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      markers: this.querySelectorAll('[data-marker]'),
      featureImages: this.querySelectorAll('[data-feature-image]'),
      slider: this.querySelector('[data-slider]'),
      actions: this.querySelectorAll('[data-action]'),
    }

    if (this.elements.markers) {
      this.elements.markers.forEach((marker) => {
        marker.addEventListener('click', this.handleMarkerClick.bind(this));
      });
    }

    if (this.elements.actions) {
      this.elements.actions.forEach((action) => {
        action.addEventListener('click', this.handleActionClick.bind(this));
      });
    }
  }

  handleMarkerClick(event) {
    event.preventDefault();
    const {currentTarget} = event;
    const blockId = currentTarget.dataset.blockId;
    let actionBlockIndex = 0;

    this.elements.actions.forEach((action, index) => {
      const actionBlockId = action.dataset.blockId;
      action.setAttribute('aria-active', actionBlockId == blockId);
      if (actionBlockId == blockId) {
        actionBlockIndex = index;
      }
    });

    this.elements.featureImages.forEach((featureImage) => {
      const featureImageBlockId = featureImage.dataset.blockId;
      featureImage.setAttribute('aria-hidden', featureImageBlockId != blockId);
    });

    const flkty = Flickity.data(this.elements.slider);

    flkty.selectCell(actionBlockIndex);
  }

  handleActionClick(event) {
    event.preventDefault();
    const {currentTarget} = event;
    const blockId = currentTarget.dataset.blockId;

    const isActive = currentTarget.getAttribute('aria-active') == "true";

    const flkty = Flickity.data(this.elements.slider);
    let actionBlockIndex = 0;

    if (isActive) {
      currentTarget.setAttribute('aria-active', false);
      this.elements.featureImages.forEach((featureImage) => {
        featureImage.setAttribute('aria-hidden', true);
      });
    } else {
      this.elements.actions.forEach((action, index) => {
        const actionBlockId = action.dataset.blockId;
        action.setAttribute('aria-active', actionBlockId == blockId);
        if (actionBlockId == blockId) {
          actionBlockIndex = index;
        }
      });

      flkty.selectCell(actionBlockIndex);

      this.elements.featureImages.forEach((featureImage) => {
        const featureImageBlockId = featureImage.dataset.blockId;
        featureImage.setAttribute('aria-hidden', featureImageBlockId != blockId);
      });
    }
  }
}

customElements.define('features-with-markers', FeaturesWithMakrkers);

class CollectionsNavigation extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;

    this.elements = {
      parentLinks: this.querySelectorAll('[data-parent-link]'),
      parentLinksSlider: this.querySelector('[data-parent-links-slider]'),
      secondLevelLinksFetchers: this.querySelectorAll('[data-fetch-second-level-links]'),
      childLinksWrapper: this.querySelector('[data-child-links-wrapper]'),
    }

    if (this.elements.secondLevelLinksFetchers) {
      this.elements.secondLevelLinksFetchers.forEach((fetcher) => {
        fetcher.addEventListener('click', this.handleFetcherClick.bind(this));
      });
    }
  }

  handleFetcherClick(event) {
    event.preventDefault();
    const {currentTarget} = event;
    this.elements.parentLinks.forEach((parentLink) => {
      parentLink.classList.remove('initially-selected');
      parentLink.querySelector('[data-parent-link-wrapper]').classList.remove('active');
    });

    currentTarget.closest('[data-parent-link-wrapper]').classList.add('active');

    const url = currentTarget.dataset.linkUrl;

    fetch(`${url}?section_id=${this.sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const receivedChildLinksWrapper = html.querySelector('[data-child-links-wrapper]');
        this.elements.childLinksWrapper.innerHTML = receivedChildLinksWrapper.innerHTML;

        themeAllSliderInt();

        if (AOS) { 
          AOS.refreshHard() 
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('collections-navigation', CollectionsNavigation);

$('[data-shipping-info-changer]').change(function(e){
  $(`.${$(this).val()}`).removeClass('hidden').siblings('.shipping-info').addClass('hidden');
});

if($('.section-main-product').length) {
     
    $('variant-radios').on('load change', function(){
       let dataStok = $('.yas-stock').attr('data-stok');
       let invetroy  = JSON.parse(document.getElementById('yas-stock-json').textContent).find((item) => {
         return item.id == this.currentVariant.id
       }).countstock;
  
       if(dataStok != 'false' && this.currentVariant.available && invetroy < 1){
         $('.yas-stock').show();
         $('.main-price[data-stok]').attr('data-stok', 'true');
       }else{
         $('.yas-stock').hide();
         $('.main-price[data-stok]').attr('data-stok', 'false');
       }

    })
}

class InfluencerAnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.designMode = this.dataset.designMode == 'true';
    this.sectionId = this.dataset.sectionId;

    this.elements = {
      messageContainer: this.querySelector('[data-influencer-message]'),
      closeButton: this.querySelector('[data-close-influencer-announcement-bar]'),
    }

    const urlParams = new URLSearchParams(window.location.search);
    this.influencersConfig = JSON.parse(this.querySelector('[data-influencers]').innerHTML);

    if (this.designMode) {
      this.classList.remove('hidden');
      slideDown(this, 500);
    } else {
      if (sessionStorage.influencer_announcement_hidden) return;

      if (urlParams.get('influencer') || sessionStorage.show_influencer_announcement) {
        this.init();
      }
    }

    if (this.elements.closeButton) {
      this.elements.closeButton.addEventListener('click', this.closeAnnouncementBar.bind(this));
    }
  }

  init() {
    const urlParams = new URLSearchParams(window.location.search);
    const influencerName = urlParams.get('influencer') || sessionStorage.show_influencer_announcement
    const influencer = this.influencersConfig[influencerName];
    if (influencer) {
      const {name, code, color, background} = influencer;
      sessionStorage.show_influencer_announcement = influencerName;
      const initialMessage = this.elements.messageContainer.innerHTML;
      const newMessage = initialMessage.replaceAll('[name]', name).replaceAll('[code]', code);
      this.style.setProperty("--color", color);
      this.style.setProperty("--background", background);
      this.elements.messageContainer.innerHTML = newMessage;
      this.classList.remove('hidden');
      slideDown(this, 500);
    }
  }

  closeAnnouncementBar(event) {
    event.preventDefault();
    sessionStorage.influencer_announcement_hidden = true;
    slideUp(this, 500);
  }
}

customElements.define('influencer-announcement-bar', InfluencerAnnouncementBar);

class DeliveryDate extends HTMLElement {
  constructor() {
    super();

    this.lowerThreshold = parseInt(this.dataset.lowerThreshold) ?? 0;
    this.higherThreshold = parseInt(this.dataset.higherThreshold) ?? 1;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const currentDate = Date.now();
    const dayInMs = 24 * 60 * 60 * 1000;
    const thresholdDifference = this.higherThreshold - this.lowerThreshold;
    
    let lowerThresholdDate, higherThresholdDate, lowerThresholdDateDayOfWeek, higherThresholdDateDayOfWeek;

    lowerThresholdDate = new Date(currentDate + (this.lowerThreshold * dayInMs));
    lowerThresholdDateDayOfWeek = lowerThresholdDate.getDay();
    
    higherThresholdDate = new Date(lowerThresholdDate.getTime() + (thresholdDifference * dayInMs));
    higherThresholdDateDayOfWeek = higherThresholdDate.getDay();

    const formattingOptions = {
      day: '2-digit',
      month: 'long',
    }
    const formattedLowerThresholdDate = new Intl.DateTimeFormat(`${Shopify.locale}-${Shopify.country}`, formattingOptions).format(lowerThresholdDate);
    const formattedHigherThresholdDate = new Intl.DateTimeFormat(`${Shopify.locale}-${Shopify.country}`, formattingOptions).format(higherThresholdDate);
    
    this.textContent = `${formattedLowerThresholdDate} - ${formattedHigherThresholdDate}`;
  }
}

if (!customElements.get('delivery-date')) {
  customElements.define('delivery-date', DeliveryDate);
}